import  {  useState } from 'react';
import { Carousel, Card } from 'react-bootstrap';
import { FaUserCircle } from 'react-icons/fa';
import StarRatings from 'react-star-ratings';  

const Testimonial = () => {
  const [reviews, setReviews] = useState([
    {
      id: 1,
      name: 'Viransha Ranade',
      occupation: 'Software Developer',
      feedback:
        "The staff at the hospital was incredible. They provided the best care during my stay. I highly recommend their services.",
      rating: 5, 
    },
    {
      id: 2,
      name: 'Charun Kumar',
      occupation: 'Teacher',
      feedback:
        "Thank you to the entire team for your exceptional service. You made my recovery easier and quicker than I expected.",
      rating: 4,
    },
    {
      id: 3,
      name: 'Atul Tile',
      occupation: 'Artist',
      feedback:
        "The staff at the hospital was incredible. They provided the best care during my stay. I highly recommend their services.",
      rating: 4,
    },
    {
      id: 4,
      name: 'Soham Patil',
      occupation: 'Principal',
      feedback: "A fantastic hospital with highly skilled professionals who genuinely care for your health and well-being.",
      rating: 5, 
    }
  ]);

  return (
    <>
      <h2 className="text-center" style={{ color: '#093c60' }}>What Our Patients Say</h2>
      <div className="testimonial-page" style={{ margin: '50px auto', maxWidth: '1200px', padding: '0 60px' }}>
        <Carousel interval={5000} >
          {reviews.map((review) => (
            <Carousel.Item key={review.id}>
              <Card className="text-center bg-light" style={{ border: 'none'}}>
                <Card.Body className="Testimonial-card" style={{ padding: '80px'  }}>
                  {/* Center the Icon */}
                  <div className="icon-container" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                    <FaUserCircle
                      size="10vw"
                      style={{ color: '#093c60' }}
                    />
                  </div>
                  <Card.Title>{review.name}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">{review.occupation}</Card.Subtitle>
                  <Card.Text>{review.feedback}</Card.Text>

                  {/* Star Ratings */}
                  <StarRatings
                    rating={review.rating} 
                    starRatedColor="#ffcc00" 
                    numberOfStars={5} 
                    starDimension="30px"
                    starSpacing="5px"
                  />

                  <Card.Text className="text-muted" style={{ fontSize: '0.9em' }}>
                    <em>Google Review</em>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default Testimonial;
